module.exports = __webpack_public_path__ + "905892c8cdb87f573f76081df5ff113e.png";